"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var curation_actions_1 = require("../actions/curation_actions");
var api_request_1 = require("../../api_request");
var lodash_1 = require("lodash");
var CURATION_PARAMS = [
    'comparison_shopping_page_id',
    'product_id',
];
function curationParams(state) {
    var whitelisted = lodash_1.pick(state, CURATION_PARAMS);
    return lodash_1.omitBy(whitelisted, function (value) { return lodash_1.isNull(value); });
}
function curationPath(state) {
    return "/admin/api/curated_sets/" + state.curated_set_id + "/curate";
}
var CurationSource = {
    fetchIndex: {
        remote: function (state) {
            return api_request_1.default.V3.get('/admin/api/curated_sets', curationParams(state));
        },
        success: curation_actions_1.default.setIndex,
        error: curation_actions_1.default.setIndexError,
    },
    curate: {
        remote: function (state) {
            return api_request_1.default.V3.post(curationPath(state), curationParams(state));
        },
        success: curation_actions_1.default.curateSuccess,
        error: curation_actions_1.default.curateError,
    },
    decurate: {
        remote: function (state) {
            return api_request_1.default.V3.destroy(curationPath(state), curationParams(state));
        },
        success: curation_actions_1.default.decurateSuccess,
        error: curation_actions_1.default.decurateError,
    },
};
exports.default = CurationSource;
//# sourceMappingURL=curation_source.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/sources/curation_source.js
// module id = lFgh
// module chunks = 20 21